import React from "react";
import { fetchInfraStatus } from "../../services/infraApi";
import EmptyState from "../common/empty_state";

class InfraStatusPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: null,
            loading: true,
            error: null,
        };
        this._interval = null;
    }

    componentDidMount() {
        this.fetchData();
        this._interval = setInterval(this.fetchData, 5000);
    }

    componentWillUnmount() {
        if (this._interval) {
            clearInterval(this._interval);
        }
    }

    fetchData = () => {
        fetchInfraStatus()
            .then((res) => {
                this.setState({ status: res?.data, loading: false, error: null });
            })
            .catch((err) => {
                this.setState({ error: err?.message || "상태 조회 실패", loading: false });
            });
    };

    formatRelativeTime(isoString) {
        if (!isoString) return "-";
        const diff = Math.floor((Date.now() - new Date(isoString).getTime()) / 1000);
        if (diff < 10) return "방금 전";
        if (diff < 60) return `${diff}초 전`;
        if (diff < 3600) return `${Math.floor(diff / 60)}분 전`;
        if (diff < 86400) return `${Math.floor(diff / 3600)}시간 전`;
        return `${Math.floor(diff / 86400)}일 전`;
    }

    render() {
        const { status, loading, error } = this.state;

        if (loading) {
            return (
                <div className="rounded-2xl border border-surface-border bg-surface-card p-4 shadow-card sm:p-6">
                    <div className="text-sm text-content-secondary">어댑터 상태를 불러오는 중...</div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="rounded-2xl border border-loss/20 bg-loss/5 p-4 shadow-card sm:p-6">
                    <div className="flex items-center gap-2">
                        <span className="inline-block h-2 w-2 rounded-full bg-loss" />
                        <span className="text-sm font-semibold text-loss">
                            BacktestInfra에 연결할 수 없습니다
                        </span>
                    </div>
                    <div className="mt-1 text-xs text-content-muted">{error}</div>
                </div>
            );
        }

        const adapters = status?.adapters || [];
        const serviceOk = adapters.length > 0 && adapters.some((a) => a.active);
        const uptime = status?.uptime || null;
        const activeCount = adapters.filter((a) => a.active).length;
        const totalCount = adapters.length;

        return (
            <div className="rounded-2xl border border-surface-border bg-surface-card p-4 shadow-card sm:p-6">
                {/* 상단 바 */}
                <div className="flex flex-wrap items-center justify-between gap-3">
                    <div className="flex items-center gap-3">
                        <h2 className="text-sm font-semibold text-content">어댑터 상태</h2>
                        <span
                            role="status"
                            aria-label={serviceOk ? "서비스 정상" : "서비스 연결 실패"}
                            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${
                                serviceOk
                                    ? "bg-gain/10 text-gain"
                                    : "bg-loss/10 text-loss"
                            }`}
                        >
                            <span
                                aria-hidden="true"
                                className={`inline-block h-1.5 w-1.5 rounded-full ${
                                    serviceOk ? "bg-gain" : "bg-loss"
                                }`}
                            />
                            {serviceOk ? "정상" : "연결 실패"}
                        </span>
                    </div>
                    <div className="flex items-center gap-4 text-xs text-content-secondary">
                        {uptime && (
                            <span>
                                가동 시간:{" "}
                                <span className="font-semibold text-content">{uptime}</span>
                            </span>
                        )}
                        <span>
                            활성:{" "}
                            <span className="font-semibold text-content">
                                {activeCount} / {totalCount}
                            </span>
                        </span>
                    </div>
                </div>

                {/* 어댑터 카드 그리드 */}
                {adapters.length === 0 ? (
                    <div className="mt-4">
                        <EmptyState title="등록된 어댑터가 없습니다" description="BacktestInfra 서비스를 확인해주세요." />
                    </div>
                ) : (
                    <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
                        {adapters.map((adapter) => {
                            const checkpointCount = adapter.checkpoint_keys ?? 0;
                            return (
                                <div
                                    key={adapter.name || adapter.id}
                                    className="rounded-xl border border-surface-border bg-surface-elevated p-3"
                                >
                                    <div className="flex items-center justify-between">
                                        <span className="text-sm font-semibold text-content">
                                            {adapter.name || adapter.id}
                                        </span>
                                        <span
                                            role="status"
                                            aria-label={adapter.active ? "활성" : "비활성"}
                                            className={`inline-block h-2.5 w-2.5 rounded-full ${
                                                adapter.active
                                                    ? "bg-gain"
                                                    : "bg-loss"
                                            }`}
                                        />
                                    </div>
                                    <div className="mt-2 flex items-center justify-between text-xs text-content-secondary">
                                        <span>체크포인트: {checkpointCount}개</span>
                                        <span>{this.formatRelativeTime(adapter.last_active_at)}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    }
}

export default InfraStatusPanel;
